import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class PrioridadeService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/prioridades`, { headers: this.account.composeHeaders() });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/prioridades/${id}`, { headers: this.account.composeHeaders() });
    }
    isUnique(descricao) {
        return this.http.post(`${SCAMP_API.accountApiV1}/prioridades/descricao/isunique`, { descricao }, { headers: this.account.composeHeaders() });
    }
    post(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/prioridades`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/prioridades/${id}`, { headers: this.account.composeHeaders() });
    }
}
PrioridadeService.ngInjectableDef = i0.defineInjectable({ factory: function PrioridadeService_Factory() { return new PrioridadeService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: PrioridadeService, providedIn: "root" });
